const reportIds = {
    showFindTabReminderBubble: '80001.3.20',
    clickFindTabReminderBubble: '80001.3.21',
    closeFindTabReminderBubble: '80001.3.22',
    recommendDocBrandClick: '80001.2.110',
    findPageContentSourceRecommend: '80001.1.163',
    findPageContentSourceHotKnowledge: '80001.1.164',
    findPageContentSourceHighValuePage: '80001.1.165',
    clickIconRecords: '80001.1.72',
    toppingRecords: '80001.1.74',
    cancelToppingRecords: '80001.1.75',
    homeQuickClick: '80001.16.1',
    homeQuickAddClick: '80001.16.2',
    homeQuickAddResult: '80001.16.3',
    homeTableClickItem: '80001.16.4',
    homeTableOperation: '80001.16.5',
    homeTableFilter: '80001.16.6',
    homeSidbarClickToMyRepository: '80001.16.7',
    homeSidbarClickToMyDepartment: '80001.16.8',
    homeSidbarClickHotDocument: '80001.16.9',
    homeSidbarHotList: '80001.16.15',
    homeClickToDepartmentManage: '80001.5.39',
    homeOpen: '80001.16.10',
    homeTableFilterMenu: '80001.16.11',
    personOpenFromTop: '80001.4.7',
    personOpenFromDepMember: '80001.4.9',
    personOpenFromRepoMember: '80001.4.8',
    openPersonFromUserTooltipIcon: '80001.4.10',
    openPersonFromUserTooltipContent: '80001.1.70',
    docLinkFromUserTooltipContent: '80001.1.71',
    startSidebarSearch: '80001.17.1',
    renderSidebarSearchList: '80001.17.2',
    clickSidebarSearchListItem: '80001.17.3',
    slideSidebarSearchListItem: '80001.17.4',
    sidebarSearchError: '80001.17.5',
    homeSidbarImportantDocShowList: '80001.16.16',
    homeSidbarClickImportantDoc: '80001.16.17',
    homeSidbarClickImportantDocMore: '80001.16.18',
    showStatisticsWeekData: '80001.5.43',
    changeStatisticsDatepicker: '80001.5.44',
    changeStatisticsDepartData: '80001.5.45',
    cancelAttentionId: '80001.2.125',
    clickAchievementToPersonalPage: '80001.1.41',
    clickHomeBannerLog: '80001.16.20',
    clickAvatarToPersonalPage: '80001.1.42',
    personalPageOnLoad: '80001.1.43',
    personalPageChangeBackgroundPageSuccess: '80001.1.44',
    personalPageChangeSentenceSuccess: '80001.1.45',
    personalPageIsUnLockDialogShow: '80001.1.46',
    personalPageIsUnLockDialogClickKnowledgeCoin: '80001.1.47',
    personalPageClickPersonalKu: '80001.1.48',
    personalPageKnowledgeCoinRulesOnLoad: '80001.1.49',
    personalPageKnowledgeCoinDetailsOnLoad: '80001.1.50',
    personalPageKnowledgeCoinBeSentOnLoad: '80001.1.51',
    personalPageKnowledLikeListBeSentOnLoad: '80001.1.90',
    personalPageClickOpenDoc: '80001.1.52',
    personalPageClickPublishTab: '80001.1.85',
    personalPageClickOpenGainCoinAndLikeDoc: '80001.1.88',
    personalPageClickOpenSendCoinDoc: '80001.1.89',
    personalPageClickGainCoinAndLikeTab: '80001.1.86',
    personalPageClickSendCoinTab: '80001.1.87',
    personalPageGainCoinAndLikeListPublishSuccess: '80001.1.94',
    personalPageGainCoinAndLikeListPublish: '80001.1.93',
    personalPageCloseSendCoinVisible: '80001.1.92',
    personalPageCloseGainCoinAndLikeVisible: '80001.1.91',
    personalPageClickOpenDocInKu: '80001.1.53',
    personalPageNotificationOnLoad: '80001.1.54',
    personalPageClickNotification: '80001.1.55',
    personalPageClickNotificationDoc: '80001.1.56',
    personalPageKnowledgeCoinSendSuccess: '80001.1.58',
    personalPageShownKnowledgeCoinGuide: '80001.1.59',
    personalPageGiveCoinDocClick: '80001.1.79',
    personalPageGiveCoinChange: '80001.1.80',
    docPublishToPersonalPage: '80001.2.144',
    docPublishToPersonalPageConfirm: '80001.2.145',
    docCancelPublishToPersonalPageConfirm: '80001.2.146',
    openPersonalReport: '80001.1.73',
    // cdn服务异常回退源站机制触发
    cdnFail: '80001.18.1',
    createStarGroupSuccess: '80001.4.17',
    starBindGroupSuccess: '80001.4.18',
    // 文档禁止复制开关点击
    docForbidCopySwitchClick: '80001.1.173',
    // 星标改名成功
    starGroupRenameSuccess: '80001.4.20',
    // 知识币成就勋章
    openAchieveDialog: '80001.1.83',
    changeAchieveLevel: '80001.1.84',
    // 个人主页公开发布按钮弹窗
    clickPersonalPagePublishBtn: '80001.1.95',
    showPersonalPagePublishDialog: '80001.1.96',
    confirmPersonalPagePublishDialog: '80001.1.97',
    // 个人主页兑换简单币相关埋点
    personalPageEnterExchangeEasyCoin: '80001.1.103',
    personalPageEnterExchangeEasyCoinRuleModal: '80001.1.104',
    personalPageExchangeEasyCoinSuccess: '80001.1.105',
    // 个人主页向 所有人/仅自己 展示个人知识库按钮
    persenalShowRepoEntryToAllBuried: '80001.1.102',
    persenalShowRepoEntryToSelfBuried: '80001.1.101',
    homeHighValueList: '80001.16.21',
    homeHighValueMore: '80001.16.22',
    giveCoinTextMore: '80001.1.120',
    // 发现页面
    findPageClick: '80001.1.110',
    findPageShow: '80001.1.111',
    findPageTabRecommend: '80001.1.112',
    findPageTabList: '80001.1.113',
    findPageRecommendList: '80001.1.114',
    findPageList: '80001.1.115',
    findPageCompleteList: '80001.1.116',
    findMoreGoodArticle: '80001.2.202',
    findPageHotList: '80001.1.136',
    exchangeEasyCoinPageActiveCoinDetail: '80001.2.203',
    usableCoinExpriedRemindTip: '80001.16.25',
    usableCoinExpriedRemindTipToGoGiveCoin: '80001.16.26',
    homeDepartmentGainCoinUserAvatar: '80001.16.27',
    // 点击榜单
    headClickTopListTab: '80001.3.25',
    // 展示榜单tab页面
    showTopListPage: '80001.1.202',
    // 点击发现页面-身边人已获币/投币文档版块内容
    findPageClickAroundPeople: '80001.3.26',
    /* 知识币盲盒 */
    // （PC）投币成功窗口显示盲盒
    showMysteryBoxDialog: '80001.2.214',
    // （PC）在投币出盲盒弹窗打开盲盒成功
    openMysteryBoxSuccess: '80001.2.215',
    // （PC）在投币出盲盒弹窗点击关闭
    closeMysteryBoxDialog: '80001.2.216',
    // 个人主页点击【我的盲盒奖励】菜单
    clickMyMysteryBoxHistory: '80001.1.146',
    // 展示【我的盲盒奖励】窗口
    showMysteryBoxHistory: '80001.1.147',
    // 展现奖品详情窗口
    showMysteryBoxDetail: '80001.1.148',
    // 在奖品详情窗口点击【查看我的可兑换知识币】
    clickMyCoinFromMysteryBox: '80001.1.149',
    // 在盲盒奖品详情窗口点击文档
    clickMysteryBoxDetailDoc: '80001.1.150',

    // 点击文档tab埋点
    personalPageLikeTab: '80001.1.132',
    // 点击我点赞 tab列表的文档
    personalPageLikeDoc: '80001.1.133',
    // 在我点赞 tab列表取消点赞成功
    personalPageCancelLikeSuccess: '80001.1.134',
    // 权限申请时切换为非推荐管理员 当用户删除推荐管理员，切换为非推荐管理员时，并发送权限申请成功后，上报埋点
    applyWithNoRecommend: '80001.1.186',
    // 个人主页显示发布文档的提醒气泡
    showHomePublicGuideShow: '80001.1.208',
    // 个人主页点击发布文档的提醒气泡
    clickHomePublicGuideShow: '80001.1.209',
    // 在「发布文档」弹窗勾选推荐文档并点击发布
    clickPublicButton: '80001.1.210',
    // 在「发布文档」弹窗点击换一批
    clickPublicReloadButton: '80001.1.211',
    // 卡片 hover点赞icon
    hoverCardLikeIcon: '80001.2.278',
    // 卡片 点赞记录曝光
    showCardLikeList: '80001.2.279',
    // 卡片 hover点赞记录
    hoverCardLikeListUserItem: '80001.2.280',
    // 卡片 点击点赞 取消点赞或者点赞
    cardLikeChange: '80001.2.281',
    // 卡片 pian 新手引导曝光
    showCardLikeNewGuid: '80001.2.282',
    // 用户hover卡片
    userHoverCard: '80001.2.276',
    // 发现-榜单页面知识达人周榜模块 曝光
    showKnowledgeeWeek: '80001.22.1',
    // 发现-榜单页面知识达人周榜模块 点击
    clickKnowledgeeWeek: '80001.22.2',
    showTemplateRecommend: '80001.8.212',
    closeTemplateRecommend: '80001.8.213',
    showTemplatePreview: '80001.8.214',
    useTemplate: '80001.8.215',

    // 用户有查看权限，进行“申请可编辑”权限
    applyEditPermission: '80001.1.224',
    // 用户有查看权限，进行“申请页面管理员”权限
    applyAdminPermission: '80001.1.226',
    // 用户有编辑权限，进行“申请页面管理员”权限
    editAdminPermission: '80001.1.225',
};

export default reportIds;
